import { connect } from 'react-redux';
import { addJournalEntryBegin } from '../../../../store/actions/accounting.actions';
import { getAccountingUpdateStatus } from '../../../../store/selectors/accounting.selectors';
import {
    getLicenseAccounting,
    getLicenseAccountingErrorStatus,
    getLicenseAccountingStatus,
} from '../../../../store/selectors/license.selectors';
import Accounting from '../../../CommonTabs/Accounting';

const mapStateToProps = (state: any) => ({
    transactionList: getLicenseAccounting(state),
    loading: getLicenseAccountingStatus(state),
    updateStatus: getAccountingUpdateStatus(state),
    errorStatus: getLicenseAccountingErrorStatus(state),
});

const mapDispatchToProps = {
    addJournalEntry: addJournalEntryBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(Accounting);
